function scrollInit() {
  if (document.documentElement.clientWidth > 1023) {
    function scrollHorizontally(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

      if (navigator.vendor.startsWith('Apple')) {
        let word = 'Version'
        let versionIndex = navigator.userAgent.indexOf(word)
        let startVersionIndex = versionIndex + word.length + 1
        let version = Number(navigator.userAgent[startVersionIndex] + navigator.userAgent[startVersionIndex + 1] + navigator.userAgent[startVersionIndex + 2] + navigator.userAgent[startVersionIndex + 3])

        if (version < 16.3) {
          wrapper.scrollLeft -= (delta * 10);
        } else {
          wrapper.scrollLeft -= (delta * 30);
        }
      } else {
        wrapper.scrollLeft -= (delta * 50 * 2);
      }
       // Multiplied by 10
      e.preventDefault();
    }
  
    let wrapper = document.querySelector('.wrapper');
  
    // IE9, Chrome, Safari, Opera
    wrapper.addEventListener("mousewheel", scrollHorizontally, false);
    // Firefox
    wrapper.addEventListener("DOMMouseScroll", scrollHorizontally, false);
  }
}

export { scrollInit }